import { OVERLAY_LAYER_GROUPS } from "./mapStyle";

export function loadActiveLayers(storage) {
  const allIds = OVERLAY_LAYER_GROUPS.map((layer) => layer.id);
  try {
    const hidden = storage.getItem("vectorLiveMapHiddenLayers");
    const active = storage.getItem("vectorLiveMapActiveLayers");
    const stored = hidden !== null ? JSON.parse(hidden) : active !== null ? JSON.parse(active) : null;
    if (stored === null) return allIds;
    if (!Array.isArray(stored) || !stored.every((id) => typeof id === "string")) {
      throw new Error("Invalid saved live map layer preferences");
    }
    return allIds.filter((id) =>
      hidden !== null ? !stored.includes(id) : stored.includes(id)
    );
  } catch (error) {
    console.error("Unable to read live map layer preferences:", error);
    return allIds;
  }
}

export function saveActiveLayers(storage, activeLayers) {
  try {
    storage.setItem("vectorLiveMapActiveLayers", JSON.stringify(activeLayers));
    storage.setItem(
      "vectorLiveMapHiddenLayers",
      JSON.stringify(
        OVERLAY_LAYER_GROUPS.filter((layer) => !activeLayers.includes(layer.id))
          .map((layer) => layer.id)
      )
    );
  } catch (error) {
    console.error("Unable to save live map layer preferences:", error);
  }
}

export function applyLayerVisibility(map, activeLayers) {
  OVERLAY_LAYER_GROUPS.forEach((layer) => {
    const ids = layer.id === "players"
      ? ["players", "players-followed"]
      : layer.groups || [layer.id];
    ids.forEach((id) => {
      if (map.getLayer(id)) {
        map.setLayoutProperty(
          id,
          "visibility",
          activeLayers.includes(layer.id) ? "visible" : "none"
        );
      }
    });
  });
}
